<!-- contentWrapper -->
<span
	class="contentWrapper--withTooltip"
	[ngClass]="{
		'cursor-default': isDisabled
	}"
	appAccessFlowCheck
	[scopes]="scopes"
	[action]="scopeAction"
	[preventDisable]="isDisabled"
	[permissionCheck]="scopePermissionCheck"
	(accessCheckResultEvent)="updateAccessCheckResult($event)"
	appNgbTooltipExtended
	[tooltipValue]="tooltipTpl"
	[container]="'body'"
	[disableTooltip]="disableTooltip || !tooltip && !tooltipHtml"
	[openDelay]="300"
	[placement]="'auto'"
>

	<!-- DROPDOWN ITEM	-->
	<button
		*ngIf="displayMode === actionDisplayModeEnum.DropdownItem"
		class="dropdown-item px-3 py-1"
		[ngClass]="{
			'disabled': isDisabled,
			'pe-none': showLoader
		}"
		appNgbTooltipExtended
		[showTooltipIndicator]="!!tooltipHtml"
		[attr.data-e2e-action]="actionItem"
		[disabled]="isDisabled"
		(click)="onClick()"
		(mouseenter)="isHovered = true"
		(mouseleave)="isHovered = false"
	>

		<!-- Loader	-->
		<ng-container
			[ngTemplateOutlet]="loaderTpl"
			[ngTemplateOutletContext]="{
				classForStyleClass: 'me-3 spinner-border spinner-border-sm'
			}"
		></ng-container>

		<!-- Icon	-->
		<ng-container
			[ngTemplateOutlet]="iconTpl"
			[ngTemplateOutletContext]="{
				classForStyleClass: 'me-3',
				classForImage: 'me-3',
				classForSvg: 'me-3'
			}"
		></ng-container>
		<span class="">{{ label }}</span>
	</button>

	<!-- Standalone	-->
	<a
		*ngIf="displayMode === actionDisplayModeEnum.Standalone"
		class="text-center page-header--action-link mx-2"
		[ngClass]="{
			'disabled': isDisabled,
			'pe-none': showLoader
		}"
		[attr.data-e2e-action]="actionItem"
		(click)="onClick()"
		(mouseenter)="isHovered = true"
		(mouseleave)="isHovered = false"
	>
		<!-- Loader	-->
		<ng-container
			[ngTemplateOutlet]="loaderTpl"
			[ngTemplateOutletContext]="{
				classForStyleClass: 'page-header--action-icon mx-2 align-middle spinner-border'
			}"
		></ng-container>

		<!-- Icon	-->
		<ng-container
			[ngTemplateOutlet]="iconTpl"
			[ngTemplateOutletContext]="{
				classForStyleClass: 'page-header--action-icon align-middle',
				classForImage: '',
				classForSvg: ''
			}"
		></ng-container>
	</a>

	<!-- Inline	-->
	<span
		*ngIf="displayMode === actionDisplayModeEnum.Inline"
		class="text-center page-action--inline"
		[ngClass]="{
			'disabled': isDisabled,
			'me-2': !label,
			'pe-none': showLoader
		}"
		appNgbTooltipExtended
		[showTooltipIndicator]="!!tooltipHtml"
		[attr.data-e2e-action]="actionItem"
		(click)="onClick()"
		(mouseleave)="isHovered = false"
		(mouseover)="isHovered = true"
	>
		<!-- Loader	-->
		<ng-container
			[ngTemplateOutlet]="loaderTpl"
			[ngTemplateOutletContext]="{
				classForStyleClass: !!label ?'me-2 spinner-border' : ''
			}"
		></ng-container>

		<!-- Icon	-->
		<ng-container
			[ngTemplateOutlet]="iconTpl"
			[ngTemplateOutletContext]="{
				classForStyleClass: !!label ?'me-2' : '',
				classForImage: !!label ?'me-2' : '',
				classForSvg: !!label ?'me-2' : ''
			}"
		></ng-container>

		<!-- Label	-->
		<span class="{{ labelStyleClass }}">{{ label }}</span>
	</span>
</span>

<!-- ######################### TEMPLATES ######################### -->
<!-- Tooltip -->
<ng-template #tooltipTpl>
	<span
		*ngIf="tooltip"
		class="d-block tooltip-value"
		[innerText]="tooltip"
	></span>

	<span
		*ngIf="tooltipHtml"
		class="d-block tooltip-value"
	>
		<ng-container *ngTemplateOutlet="tooltipHtml"></ng-container>
	</span>
</ng-template>

<!-- Loader -->
<ng-template
	#loaderTpl
	let-classForStyleClass="classForStyleClass"
>
	<i
		*ngIf="showLoader"
		class="{{classForStyleClass}}"
		[ngClass]="{
			'spinner-border-sm': showSmallLoaderIcon
		}"
	></i>
</ng-template>

<!-- Icon -->
<ng-template
	#iconTpl
	let-classForImage="classForImage"
	let-classForStyleClass="classForStyleClass"
	let-classForSvg="classForSvg"
>

	<ng-container
		*ngIf="!showLoader"
		[ngSwitch]="actionIconType"
	>
		<!-- by class	-->
		<i
			*ngSwitchCase="actionIconTypeEnum.StyleClass"
			class="align-middle {{classForStyleClass + ' ' +  iconClass + ' ' + getFontIconSize()}}"
			[ngClass]="iconClassMap"
		></i>

		<!-- by image	-->
		<img
			*ngSwitchCase="actionIconTypeEnum.Image"
			class="{{ classForImage }}"
			[ngClass]="{'disabled': isDisabled}"
			[attr.alt]="label || tooltip"
			[src]="imageSrcPath"
		>

		<!-- by svg	-->
		<app-svg
			*ngSwitchCase="actionIconTypeEnum.SVG"
			class="{{ classForSvg }}"
			[fillable]="svgFillable"
			[size]="getSVGSize()"
			[stateArray]="isHovered ? [svgStateEnum.HOVER] : [svgStateEnum.NORMAL]"
			[strokeable]="svgStrokeable"
			[type]="svgType"
		></app-svg>
	</ng-container>
</ng-template>
